import React from 'react';

const DataItem = ({label, value}) => (
  <div className="modal-data-item">
    <div className="modal-data-item__label">{label}</div>
    <div className="modal-data-item__value">{value}</div>
  </div>
);

export default DataItem;